import { createFileRoute } from '@tanstack/react-router'
import { DocumentsTab } from '~/components/routes/development/real-estate/store-project/store-project-modal/documents-tab'
import { useStoreProjectModalTab } from '~/components/routes/development/real-estate/store-project/store-project-modal/modal-tab-context'

export const Route = createFileRoute(
  '/_authenticated/development/real-estate/kanban/$cardId/documents',
)({
  component: DocumentsTabRoute,
})

function DocumentsTabRoute() {
  const tab = useStoreProjectModalTab()
  return (
    <DocumentsTab
      projectId={tab.project?.id}
      canEdit={tab.canEdit}
      queuedDocuments={tab.queuedDocuments}
      onQueueDocument={tab.handleQueueDocument}
      onRemoveQueuedDocument={tab.handleRemoveQueuedDocument}
    />
  )
}
